import React from 'react'
import { Outlet } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

const Home = () => {
   return (
      <Grid
         container
         sx={{
            minHeight: '100vh',
            bgcolor: '#FFFFFF',
         }}
      >
         <Grid
            item
            md={6}
            lg={6}
            sx={{
               display: { xs: 'none', md: 'flex' },
               position: 'relative',
               overflow: 'hidden',
               minHeight: '100vh',
               backgroundImage: `
                  radial-gradient(
                     circle at 15% 20%,
                     rgba(0,169,206,0.18) 0,
                     rgba(0,169,206,0) 32%
                  ),
                  radial-gradient(
                     circle at 90% 80%,
                     rgba(47,128,237,0.14) 0,
                     rgba(47,128,237,0) 35%
                  ),
                  linear-gradient(
                     135deg,
                     #0A2034 0%,
                     #163A5F 58%,
                     #102E4B 100%
                  )
               `,
            }}
         >
            <Box
               sx={{
                  position: 'absolute',
                  inset: 0,
                  opacity: 0.07,
                  backgroundImage: `
                     linear-gradient(
                        rgba(255,255,255,0.35) 1px,
                        transparent 1px
                     ),
                     linear-gradient(
                        90deg,
                        rgba(255,255,255,0.35) 1px,
                        transparent 1px
                     )
                  `,
                  backgroundSize: '44px 44px',
               }}
            />

            <Box
               sx={{
                  position: 'absolute',
                  width: '420px',
                  height: '420px',
                  borderRadius: '50%',
                  border: '1px solid rgba(0,169,206,0.16)',
                  right: '-180px',
                  top: '-130px',
               }}
            />

            <Box
               sx={{
                  position: 'relative',
                  zIndex: 1,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  px: { md: 7, lg: 10 },
                  py: { md: 7, lg: 9 },
               }}
            >
               <Box>
                  <Box
                     sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        mb: 1,
                     }}
                  >
                     <Box
                        sx={{
                           color: '#FFFFFF',
                           fontSize: { md: '34px', lg: '40px' },
                           fontWeight: 700,
                           lineHeight: 1,
                           letterSpacing: '-1px',
                           whiteSpace: 'nowrap',
                        }}
                     >
                        FILE HUB
                     </Box>

                     <Box
                        sx={{
                           bgcolor: '#00A9CE',
                           color: '#FFFFFF',
                           px: '10px',
                           py: '4px',
                           borderRadius: '999px',
                           fontSize: '11px',
                           fontWeight: 800,
                           lineHeight: 1,
                           letterSpacing: '0.5px',
                           width: 'auto',
                           flex: '0 0 auto',
                           boxShadow:
                              '0 3px 10px rgba(0,169,206,0.25)',
                        }}
                     >
                        V2
                     </Box>
                  </Box>

                  <Box
                     sx={{
                        color: 'rgba(255,255,255,0.72)',
                        fontSize: '11px',
                        fontWeight: 700,
                        letterSpacing: '1.8px',
                     }}
                  >
                     BY ZIPTUNING
                  </Box>
               </Box>

               <Box sx={{ maxWidth: '520px' }}>
                  <Box
                     sx={{
                        color: '#FFFFFF',
                        fontSize: { md: '34px', lg: '43px' },
                        lineHeight: 1.16,
                        fontWeight: 600,
                        letterSpacing: '-1px',
                        mb: 2.5,
                     }}
                  >
                     Calibration files.
                     <br />
                     One hub.
                  </Box>

                  <Box
                     sx={{
                        color: 'rgba(255,255,255,0.67)',
                        fontSize: { md: '14px', lg: '16px' },
                        lineHeight: 1.7,
                        maxWidth: '450px',
                        mb: 5,
                     }}
                  >
                     Upload vehicle files, follow your orders and
                     receive completed calibration files directly
                     through File Hub.
                  </Box>

                  <Box
                     sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                     }}
                  >
                     {[
                        'Secure file handling',
                        'Clear order overview',
                        'Direct tuner support',
                     ].map((text) => (
                        <Box
                           key={text}
                           sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              color: 'rgba(255,255,255,0.82)',
                              fontSize: '14px',
                              fontWeight: 500,
                           }}
                        >
                           <Box
                              sx={{
                                 width: '7px',
                                 height: '7px',
                                 borderRadius: '50%',
                                 bgcolor: '#00A9CE',
                                 boxShadow:
                                    '0 0 12px rgba(0,169,206,0.55)',
                              }}
                           />
                           {text}
                        </Box>
                     ))}
                  </Box>
               </Box>

               <Box
                  sx={{
                     display: 'flex',
                     alignItems: 'center',
                     gap: 1.5,
                     color: 'rgba(255,255,255,0.40)',
                     fontSize: '11px',
                     letterSpacing: '0.7px',
                     transform: 'translateY(22px)',
                  }}
               >
                  <Box
                     sx={{
                        width: '22px',
                        height: '1px',
                        bgcolor: '#00A9CE',
                     }}
                  />
                  PROFESSIONAL FILE SERVICE
               </Box>
            </Box>
         </Grid>

         <Outlet />
      </Grid>
   )
}

export default Home